import { css } from '@emotion/react';
import * as tokens from '@tokens';

export const baseStyles = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  outline: none;
  ${tokens.transition('background-color')};
  cursor: pointer;
  white-space: nowrap;
  border-radius: ${tokens.radius.m};
  ${tokens.text('subtitle2')};
  ${tokens.elevation(1)};
  padding: 0;
`;

const getSecondaryStyles = (color, colorAlt) => css`
  color: ${color};
  background-color: transparent;
  box-shadow: inset 0 0 0 1px ${color};
  &:hover {
    box-shadow: inset 0 0 0 2px ${colorAlt};
  }
  &:focus {
    ${`${tokens.focus()}, inset 0 0 0 2px ${colorAlt}`};
    color: ${colorAlt};
  }
  &:active {
    ${`${tokens.elevation(-1)}, inset 0 0 0 2px ${colorAlt}`};
  }
  &:hover,
  &:active {
    color: ${colorAlt};
  }
`;

export const secondaryStyles = getSecondaryStyles(
  tokens.color.secondary_cta,
  tokens.color.secondary_cta_alt,
);

export const ghostStyles = css`
  color: ${tokens.color.text_default};
  background-color: transparent;
  ${tokens.elevation(0)};
  &:focus {
    ${tokens.focus()};
  }
  &:active {
    ${tokens.elevation(-1)};
  }
  &:hover,
  &:active {
    background-color: ${tokens.color.bg_hover};
  }
`;

const dangerInteractionStyles = css`
  &:focus {
    color: ${tokens.color.text_danger};
  }
  &:hover {
    ${tokens.elevation(0)}
  }
  &:hover,
  &:active {
    color: ${tokens.color.text_default_inverse};
    background-color: ${tokens.color.danger_cta_alt};
  }
`;

export const dangerSecondaryStyles = getSecondaryStyles(
  tokens.color.danger_cta,
  tokens.color.danger_cta_alt,
);

export const dangerGhostStyles = css`
  ${ghostStyles}
  &:focus {
    ${tokens.focus()};
  }
  ${dangerInteractionStyles}
`;
